module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-container"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "info-box",
      class: _vm.selectIndex == index ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.onSelectTech(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "tech-title",
      domProps: {
        "textContent": _vm._s(item.dictValue)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tech-desc",
      domProps: {
        "textContent": _vm._s(item.extraValue)
      }
    })])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddb7d168","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Proteomics/components/QualitativeTeach.vue
// module id = 1731
// module chunks = 8